export default [
  {
    _tag: "CSidebarNavItem",
    name: "Inicio",
    to: "/inicio",
    icon: "cil-speedometer",
  },
  {
    _tag: "CSidebarNavTitle",
    _children: ["Reservas"],
  },
  {
    _tag: "CSidebarNavItem",
    name: "Servicios",
    to: "/reserva/servicios",
    icon: "cil-drop",
  },
  {
    _tag: "CSidebarNavItem",
    name: "Privado",
    to: "/privado",
    icon: "cil-pencil",
    target: "_blank"
  },
  // {
  //   _tag: "CSidebarNavItem",
  //   name: "Asistentes",
  //   to: "/reserva/asistentes",
  //   icon: "cil-pencil",
  // },
];
